export default __webpack_public_path__ + "static/grunge-long-scroll-7538b20b4df205782efec9ab73fff656.png";